import { isInternationalTransfer } from 'src/core/utils/isInternationalTransfer';

type PaymentVerificationOfPayeeParams = {
  companyCurrency: string;
  targetCurrency: string;
  targetCountry: string | undefined;
  isWireTransferAvailable: boolean;
};

export const isPaymentVerificationOfPayeeCompatible = ({
  companyCurrency,
  targetCurrency,
  targetCountry,
  isWireTransferAvailable,
}: PaymentVerificationOfPayeeParams): boolean => {
  const isNonInternationalEurPayment =
    companyCurrency === 'EUR' &&
    !isInternationalTransfer({
      sourceCurrency: companyCurrency,
      targetCurrency,
      targetCountry,
    });

  return isNonInternationalEurPayment && isWireTransferAvailable;
};
